import { AppActions } from '../rootActions';
import * as ContactusConstants from './constants';
import * as ContactusModels from './models';

export const submit = (payload: ContactusModels.SubmitMessagePayload): AppActions => ({
  type: ContactusConstants.SUBMIT,
  payload,
});
